<!-- Header — dark bg matching sidebar, uses --zt-anthracite token -->
<div class="zt-header relative flex flex-0 items-center w-full h-14 px-4 md:px-6 z-49 border-b border-white/[0.06] print:hidden">

    <div class="flex items-center gap-2" *transloco="let t">

        <!-- Navigation toggle button -->
        <button
            class="flex items-center justify-center size-9 rounded-lg border border-white/10 text-white/60 hover:text-white/90 hover:border-white/20 hover:bg-white/[0.06] transition-all duration-150 cursor-pointer"
            (click)="toggleNavigation()">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:menu-alt-1'"></mat-icon>
        </button>

        <!-- Module selector -->
        @if (module) {
            <button
                (click)="openDialog()"
                class="zt-header__module-btn flex items-center gap-1.5 h-9 pl-3.5 pr-2.5 rounded-lg border border-white/10 text-white/90 font-semibold text-[13px] capitalize transition-all duration-150 group"
            >
                <span class="truncate max-w-48">{{t(module.title)}}</span>
                <mat-icon class="zt-header__chevron icon-size-4 text-white/40 transition-colors duration-150" [svgIcon]="'heroicons_solid:chevron-down'"></mat-icon>
            </button>
        }
    </div>

    <!-- Right actions -->
    <div class="flex items-center ml-auto gap-1">
        <languages></languages>
        <!-- <fullscreen class="hidden md:block"></fullscreen> -->
        <!-- <search [appearance]="'bar'"></search> -->
        <!-- <shortcuts></shortcuts> -->
        <!-- <messages></messages> -->
        <notifications></notifications>
        <user></user>
    </div>
</div>
